export async function flush({ commit, dispatch }) {
  commit('flush');
  dispatch('application/flush', null, { root: true });
}
